class ProductDetailActions extends ProductDetailActionsBase {
    constructor(el) {
        super(el);

        //Přihlášení uživatelé nemají tento text dostupný
        this.betterPriceForLoggedUserText = this.$find('[data-better-price-for-logged-user-text]');
        if (this.betterPriceForLoggedUserText) {
            this.loadLoginOpennerAndSetListener();
        }
    }

    onVariantChange(variant) {
        super.onVariantChange(variant);

        if (this.betterPriceForLoggedUserText) {
            this.betterPriceForLoggedUserText.innerHTML = variant.betterPriceForLoggedUserText
            this.loadLoginOpennerAndSetListener();
        }
    }

    loadLoginOpennerAndSetListener() {
        this.loginOpener = this.$find('[data-login-opener]');
        this.loginOpener && this.loginOpener.addEventListener('click', () => this.openLogin());
    }

    openLogin() {
        EventBus.getInstance().dispatchEvent('showBasePopup', 'login-popup');
    }
}
